import { formatDollarAmount } from "utils/Formatters";

const OfferInMessage = ({ message, handleEvent, isMine }) => {
  return (
    <>
      <div className="rounded-lg bg-[#F9F9F9] p-[10px] w-full">
        <div className="flex items-center w-full justify-between">
          <div className="flex flex-col text-center pl-2">
            <span className="text-[#213E98] text-[18.6px] font-medium mb-1">
              {isMine ? "You" : message?.from_name} Submitted an Offer
            </span>
            <span className="text-[#ED1D24] font-bold text-[37px] leading-8">
              {formatDollarAmount(message?.offer_amount)}
            </span>
          </div>
          <div className="border border-[#D2D6DA] bg-white rounded-lg px-3 py-1 ml-4">
            <p className="text-[#2E2E2E]/50 text-[13.9px] w-[375px] h-[62px] overflow-y-scroll">
              {message?.offer_message}
            </p>
          </div>
        </div>

        <div className="flex mt-5 px-2 justify-between mb-2">
          <button
            onClick={() => handleEvent("approve_offer")}
            disabled={
              isMine ||
              message?.offer_accepted_date ||
              message?.offer_rejected_date ||
              message?.counter_offer_id
            }
            className="bg-[#213E98] text-[#F9F9F9] rounded-md shadow-[0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] font-medium text-[13px] tracking-[.73px] w-[160px] h-[36px] disabled:opacity-20"
          >
            Approve Offer
          </button>
          <button
            onClick={() => handleEvent("decline_offer")}
            disabled={
              isMine ||
              message?.offer_accepted_date ||
              message?.offer_rejected_date ||
              message?.offer_rejected_date
            }
            className="bg-[#E9392C] text-[#F9F9F9] rounded-md shadow-[0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] font-medium text-[13px] tracking-[.73px] w-[160px] h-[36px] disabled:opacity-20"
          >
            Decline Offer
          </button>
          <button
            onClick={() => handleEvent("counter_offer")}
            disabled={
              isMine ||
              message?.offer_accepted_date ||
              message?.offer_rejected_date ||
              message?.counter_offer_id
            }
            className="bg-[#FDE8E9] text-[#ED1D24] rounded-md shadow-[0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] font-medium text-[13px] tracking-[.73px] w-[160px] h-[36px] disabled:opacity-20"
          >
            Counter Offer
          </button>
          <div className="w-[160px] h-[36px]" />
          {/* <button
            onClick={() => handleEvent("offer_details")}
            className="bg-[#989BA03D] text-[#213E98] rounded-md shadow-[0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] font-medium text-[13px] tracking-[.73px] w-[160px] h-[36px]"
          >
            More Information
          </button> */}
        </div>
      </div>

      {message?.offer_accepted_date && (
        <div className="mt-3 text-xl">Congrats your offer was accpeted</div>
      )}

      {message?.offer_rejected_date && (
        <div className="mt-3 text-xl">The offer was declined</div>
      )}
    </>
  );
};

export default OfferInMessage;
